import { useFlags } from 'launchdarkly-react-client-sdk';

import { KIOSK_CONCIERGE_ROLLOUT_FLAG } from '@dutchie/common/utils/concierge-rollout';

type DispensaryWithKioskConciergeSetting =
  | {
      id?: string | null;
      /** Includes the enterprise Concierge AI setting and the store's kiosk toggle. Missing/null fails closed. */
      conciergeChannels?: { kiosk?: boolean | null } | null;
    }
  | null
  | undefined;

/**
 * Kiosk concierge is on only when the LD rollout flag and the
 * `conciergeChannels.kiosk` resolver field are both exactly `true` (fail
 * closed). The channel accounts for the super-admin enterprise Concierge AI
 * setting AND the store's kiosk `enableKioskConcierge` toggle.
 * Kiosk never inherits the web channel. This is the live gate;
 * ConciergePage latches the flag itself.
 */
export function useIsKioskConciergeEnabled(dispensary: DispensaryWithKioskConciergeSetting): boolean {
  const flags = useFlags();
  return isKioskConciergeSettingOn(dispensary) && flags[KIOSK_CONCIERGE_ROLLOUT_FLAG] === true;
}

export function isKioskConciergeSettingOn(dispensary: DispensaryWithKioskConciergeSetting): boolean {
  return dispensary?.conciergeChannels?.kiosk === true;
}
